<template>
  <div>
    <div class="top_flex">
      <div style="">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <!-- <el-breadcrumb-item :to="{ path: '/HomePage' }">
            <span v-if="$router.history.current.path != '/HomePage'" style="color: #383838;">首页</span>
            <span style="font-size: 30px;font-weight: bold;margin-left: 5px;color: #383838;" v-else>捷安特云盘系统</span>
          </el-breadcrumb-item> -->
          <el-breadcrumb-item v-if="$router.history.current.path != '/HomePage'"
            :to="{ path: $router.history.current.path }">{{ $router.history.current.meta.title }}
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="list.length > 0">
            <span style="cursor: pointer;" @click="getto('', '', false)">返回上一级</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in list" :key="index">
            <div style="cursor: pointer;" class="text-ellipsis-100" @click="getto(item, index, true)">{{ item.title }}</div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div  class="display_flex_center" style="justify-content: flex-end;width:40%;">
        <div style="margin-right:10px;" @click="searchMain"
          v-if="$router.history.current.path != '/homepagemain' && $router.history.current.path != '/HomePage'">
          <el-input v-model="input" placeholder="请输入云盘文件名称" style="border-radius: 30px;" readonly>
            <i slot="prefix" class="iconfont icon-search" style="color:#808080 ;"></i>
          </el-input>
        </div>
        <div class="user_info_img">
          <img :src="$store.state.adminuserinfo.avatar ? setavatar($store.state.adminuserinfo.avatar) : avatarimg" @error="setDefaultImage" alt="">
        </div>
        <div class="user_info_name">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="cursor: pointer;">
              {{ $store.state.adminuserinfo.staffName ? $store.state.adminuserinfo.staffName : $store.state.adminuserinfo.userName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/HomePage">首页</el-dropdown-item>
              <el-dropdown-item command="/">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { logout } from '@/api/login/index.js'
export default {
  watch: {
    fileslist(val) { 
      this.list = val
    }
  },
  props: {
    fileslist: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: this.fileslist,
      breadList: [],
      avatarimg: require('../../assets/img/info.png'),
      input: '',
      isFull: true,
    }
  },
  mounted() {
  },
  computed: {

  },
  methods: {
    setavatar(val) { 
      if (val && val.indexOf("http://") > -1) {
        return this.$avatarimg + "/index.php/api/getImg?url=" + val
      } else { 
        return val
      }
    },
    setDefaultImage(e) {
      e.target.src = this.avatarimg
    },
    handleCommand(command) {
      let _this = this
      if (command == '/') {
        logout().then(res => {
          localStorage.clear()
          sessionStorage.clear()
          _this.$router.push(command)
          _this.loading = false
        })
          .catch(err => {
            _this.loading = false
          })
      } else {
        this.$router.push(command)
      }
    },
    searchMain() {
      this.$router.push({ path: '/homepagemain' })
    },
    // 
    // 返回上一页
    getto(item, index, type) {
      this.$emit('backfile', item, index, type)
    }
  },
}
</script>
<style lang='less' scoped>

/deep/ .el-breadcrumb__inner.is-link{
    color: #4E66FF;
}

/deep/  .el-dropdown-menu__item:hover {
  color: #4E66FF;
}

.el-breadcrumb__item{
  display: flex;
  padding: 5px;
}

.top_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background: #fff;
  padding: 0 10px;
  border-bottom: 1px solid #EBEBEB;
}

/deep/ .el-input__inner {
  background: #F6F6F7;
  border: none;
  cursor: pointer;
}

.user_info_img {
  width: 32px;
  height: 32px;
  border-radius: 50px;
  overflow: hidden;

  img {
    height: 100%;
  }
}

.user_info_name {
  padding: 0 10px;
}


.el-dropdown-link {
  cursor: pointer;
  color: #4E66FF;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
